import { createAction } from '@reduxjs/toolkit';

import { IEmail, IError } from '../../interfaces';

export const resetAppStatus = createAction('app.reset-app-status');

export const sendEmail = createAction<{ email: IEmail }>('app.send-email');
export const sendEmailSucceeded = createAction('app.send-email.succeeded');
export const sendEmailFailed = createAction<IError>('app.send-email.failed');
